import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  drawerPaper: {
    width: "85vw !important",
    maxWidth: "1280px !important",
    background: "transparent !important",
    boxShadow: "none !important",
    border: "none !important",
  },
  drawerContainer: {
    height: "100%",
    padding: "8px",
    display: "flex",
    gap: "8px",
  },
  navigationPanel: {
    width: "240px",
    flexShrink: 0,
    background: "#F8F9FC",
    padding: "24px 16px",
    borderRadius: "12px",
  },
  navigationTitle: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "uppercase",
    lineHeight: "14px",
    letterSpacing: "1.2px",
    color: "#667085",
    margin: "0 0 16px 12px",
  },
  activeNavItem: {
    display: "flex",
    padding: "10px 12px",
    alignItems: "center",
    color: "#475467",
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    borderRadius: "6px",
    background: "#FFFFFF",
  },
  contentPanel: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    background: "#FFFFFF",
    minWidth: 0,
    overflow: "hidden",
    borderRadius: "12px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
    background: "#EDF5FB",
    flexShrink: 0,
    borderBottom: "1px solid #EAECF0",
  },
  title: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#308CDB",
    fontFamily: "Manrope",
    lineHeight: "24px",
  },

  scrollableContent: {
    flexGrow: 1,
    overflowY: "auto",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    background: "#F9FAFB",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  sectionTitle: {
    color: "var(--Text-Default, #465869)",
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "24px",
  },
  originFile: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "var(--Neutral-Gray-600, #475467)",
    fontFamily: "Manrope",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
  },
  detailLabel: {
    color: "var(--shipeezi-2, #308CDB)",
    fontFamily: "Manrope",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "24px",
  },
  contentTab: {
    display: "inline-flex",
    padding: "4px 8px",
    alignItems: "center",
    borderRadius: 4,
    background: "var(--Gray-Light-Gray, #EDF5FB)",
    color: "var(--shipeezi-2, #308CDB)",
    fontFamily: "Manrope",
    fontSize: 10,
    fontWeight: 600,
    lineHeight: "20px",
    border: "none",
  },
  section: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #EAECF0",
    borderRadius: "12px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  previewWrapper: {
    border: "1px solid #EAECF0",
    borderRadius: "8px",
    padding: "24px",
    background: "#FFFFFF",
  },
  templatePreview: {
    padding: 0,
    textAlign: "left",
    border: "none",
    background: "none",
  },
}));

export default useStyles;
